/**
 * Job period filter.
 */
export enum JobPeriodFilterOption {
  /**
   * All jobs period filter option.
   */
  All,
  /**
   * Current jobs period filter option.
   */
  Current,
  /**
   * Old jobs period filter option.
   */
  Old,
}
